import React from 'react';

var MobileHeaderWr = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: 'pgc-m-header' }, children));
};

export { MobileHeaderWr };
